const rawBuildProfile = String(
  process.env.REACT_APP_BUILD_PROFILE || "web"
).trim().toLowerCase();

export const APP_BUILD_PROFILE = rawBuildProfile || "web";
export const IS_MOBILE_BUILD = APP_BUILD_PROFILE.startsWith("mobile-");
export const IS_MOBILE_DEV_BUILD = APP_BUILD_PROFILE === "mobile-dev";
export const IS_MOBILE_RELEASE_BUILD = APP_BUILD_PROFILE === "mobile-release";

// Internal tooling is web-only. Capacitor serves its bundled UI from localhost,
// so neither development nor release mobile builds may include local/staff tools.
export const INCLUDE_INTERNAL_TOOLS = !IS_MOBILE_BUILD;
export const INCLUDE_MARKETING_ROUTES = !IS_MOBILE_RELEASE_BUILD;
